import React, {useEffect, useState} from "react";
import { getUserAuthData } from "../../../auth/authHelper";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import {useAction} from "../../../../store/hooks/useAction";
import {Page, Preloader, Navbar, Fab, FabButtons, FabButton, Icon} from "framework7-react";
import QuickbetListPage from "../Components/QuickbetListPage";
import {QuickbetCreateModal} from "./QuickbetCreateModal";
import {MainToolBar} from "../../../MainLayout/MainToolBar";
export const QuickbetList = () => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const userData = getUserAuthData();
    const operatorName = userData?.operators?.[0];
    const {getQuickbetsData} = useAction();
    const {quickbetsData, loading} = useTypedSelector((state) => state.quickbetsReducer);
    const openModal = (type: string) => {

        if (type === "create") {
            setCreateModalOpen(true)
        }
    }
    useEffect(() => {
        if (operatorName) {
            getQuickbetsData(operatorName);
        }
    },[operatorName])
    return (
        <>
            <Page>
                <Navbar title="Quickbet" backLink="Back" />
                {loading ? <Preloader /> : <QuickbetListPage data={quickbetsData} openModal={openModal} />}
                <QuickbetCreateModal opened={createModalOpen} onClose={() => setCreateModalOpen(false)} />
                <Fab position="right-bottom" slot="fixed">
                    <Icon ios="f7:plus" md="material:add" />
                    <Icon ios="f7:xmark" md="material:close" />
                    <FabButtons position="top">
                        <FabButton label="Create Quickbet" onClick={() => { openModal("create") }}>1</FabButton>
                        <FabButton label="Create Smarbet">2</FabButton>
                        <FabButton label="Create Jackpot">3</FabButton>
                    </FabButtons>
                </Fab>
                <MainToolBar />
            </Page>
        </>
    );
};
